import { useState } from 'react';
import { Form } from 'antd';
import { Dayjs } from 'dayjs';
import { Calendar, Radio as CustomRadio } from '@/components';
import { StepCompProps } from '../../add-member';
import { MemberWrapper } from '../member-wrapper';
import cx from './index.module.scss';

const validBirthday = (_, value) => {
  if (!value) {
    return Promise.reject('出生日期不能为空');
  }
  if (!value.isValid()) {
    return Promise.reject('请输入正确的出生日期');
  }
  return Promise.resolve('');
};

const GENDER_OPTIONS = [
  { label: '女', value: 'Female' },
  { label: '男', value: 'Male' },
];

const BirthdayStep = (props: StepCompProps) => {
  const { form, hidden, className } = props;
  const [value, setValue] = useState<Dayjs>(null);
  // const [customerSources, setCustomerSources] = useState<GetCustomerSourcesResponse[]>([]);
  // const getCustomerSources = useCallback(async () => {
  //   const { data } = await service.customer.getCustomerSources();
  //   setCustomerSources(data);
  //   form.setFieldValue('source', data[0]?.key);
  // }, [form]);

  // useEffect(() => {
  //   getCustomerSources();
  // }, [getCustomerSources]);

  return (
    <div className={cx('wrapper', className)}>
      <Form.Item hidden={hidden} name="birthday" rules={[{ required: true, validator: validBirthday }]}>
        <MemberWrapper title={'出生日期'}>
          <Calendar
            className={cx('calendar-wrapper')}
            placeholder="请输入日期"
            mode="date"
            onChange={v => setValue(v as Dayjs)}
            value={value}
          />
        </MemberWrapper>
      </Form.Item>

      <Form.Item name="gender" hidden={hidden} rules={[{ required: true }]}>
        <MemberWrapper title="性别">
          <CustomRadio className={cx('radio-wrapper-gender')}>
            {GENDER_OPTIONS?.map(item => (
              <CustomRadio.Item name={item.value} key={item.value}>
                {item.label}
              </CustomRadio.Item>
            ))}
          </CustomRadio>
        </MemberWrapper>
      </Form.Item>
      {/** 1.9.10版本去掉会员来源 */}
      {/* <Form.Item name="source" hidden={hidden} rules={[{ required: true }]}>
        <MemberWrapper title={'会员来源'}>
          <CustomRadio className={cx('radio-wrapper')}>
            {customerSources.map(item => (
              <CustomRadio.Item name={item.key} key={item.key}>
                {item.value}
              </CustomRadio.Item>
            ))}
          </CustomRadio>
        </MemberWrapper>
      </Form.Item> */}
    </div>
  );
};

export { BirthdayStep };
